import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { ApiModule, Configuration } from './api';
import { environment } from '../environments/environment';

// 1. IMPORT THE SERVICE
import { SignNotificationService } from './core/sign-notification.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // 2. ADD IT HERE
    SignNotificationService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideOAuthClient(),
    importProvidersFrom(
      ApiModule.forRoot(() => new Configuration({ basePath: environment.downloaderApiBase }))
    )
  ]
};